export const formatOrderStatus = (status) => {
  switch (status) {
    case 'pending':
      return 'Na čekanju';
    case 'pending_paid':
      return 'Na čekanju (plaćeno)'
    case 'processing':
      return 'U obradi';
    case 'shipped':
      return 'Poslato';
    case 'delivered':
      return 'Dostavljeno';
    case 'cancelled':
      return 'Otkazano';
    case 'returned':
      return 'Vraćeno';
    case 'ready_for_pickup':
      return 'Spremno za preuzimanje';
    case 'vip':
      return 'VIP Članstvo';
    default:
      return 'Nepoznat status';
  }
};

export const formatOrderStatusAsPill = (status) => {
  const pillStyle = {
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-block'
  };
  switch (status) {
    case 'pending':
      return <span style={{ ...pillStyle, backgroundColor: '#FEF0C7', color: '#DC6803' }}>Na čekanju</span>;
    case 'pending_paid':
      return <span style={{ ...pillStyle, backgroundColor: '#FEF0C7', color: '#DC6803' }}>Na čekanju (plaćeno)</span>;
    case 'processing':
      return <span style={{ ...pillStyle, backgroundColor: '#EFF8FF', color: '#175CD3' }}>U obradi</span>;
    case 'shipped':
      return <span style={{ ...pillStyle, backgroundColor: '#F4F3FF', color: '#5925DC' }}>Poslato</span>;
    case 'delivered':
      return <span style={{ ...pillStyle, backgroundColor: '#ECFDF3', color: '#027A48' }}>Dostavljeno</span>;
    case 'cancelled':
      return <span style={{ ...pillStyle, backgroundColor: '#FEF3F2', color: '#B42318' }}>Otkazano</span>;
    case 'returned':
      return <span style={{ ...pillStyle, backgroundColor: '#F2F4F7', color: '#344054' }}>Vraćeno</span>;
    case 'ready_for_pickup':
      return <span style={{ ...pillStyle, backgroundColor: '#ECFEFF', color: '#0E7490' }}>Spremno za preuzimanje</span>;
    case 'vip':
      return <span style={{ ...pillStyle, backgroundColor: '#FEF7C3', color: '#854D0E' }}>VIP Članstvo</span>;
    default:
      return <span style={{ ...pillStyle, backgroundColor: '#F2F4F7', color: '#344054' }}>Nepoznat status</span>;
  }
};

const CHANNEL_LABELS = {
  mobile: 'Mobilna aplikacija',
  web: 'Web',
};

// When an order came in through a mentor's referral, who it came through is
// what the admin needs to see — it replaces the app/web label, which stays
// available as the pill's tooltip. A Mentor Package purchase (the order that
// grants the buyer mentor status, see mentor-package.service.ts on the backend)
// takes priority over that — it's the more salient fact about the order, and is
// unrelated to whether the buyer themselves was referred by another mentor.
export const formatOrderChannelAsPill = (channel, mentor, isMentorPackage) => {
  const pillStyle = {
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-block'
  };
  if (isMentorPackage) {
    return (
      <span
        title={CHANNEL_LABELS[channel] || undefined}
        style={{ ...pillStyle, backgroundColor: '#FEF7C3', color: '#854D0E' }}
      >
        Mentorski paket
      </span>
    );
  }
  if (mentor) {
    const mentorName = [mentor.firstName, mentor.lastName]
      .filter(Boolean)
      .join(' ');
    return (
      <span
        title={CHANNEL_LABELS[channel] || undefined}
        style={{ ...pillStyle, backgroundColor: '#ECFDF3', color: '#027A48' }}
      >
        {mentorName ? `Mentor: ${mentorName}` : 'Mentor'}
      </span>
    );
  }
  switch (channel) {
    case 'mobile':
      return <span style={{ ...pillStyle, backgroundColor: '#EFF8FF', color: '#175CD3' }}>Mobilna aplikacija</span>;
    case 'web':
      return <span style={{ ...pillStyle, backgroundColor: '#F4F3FF', color: '#5925DC' }}>Web</span>;
    default:
      return <span style={{ ...pillStyle, backgroundColor: '#F2F4F7', color: '#344054' }}>—</span>;
  }
};

export const ORDER_STATUSES = [
  { key: 'pending', label: 'Na čekanju' },
  { key: 'pending_paid', label: 'Na čekanju (plaćeno)' },
  { key: 'processing', label: 'U obradi' },
  { key: 'shipped', label: 'Poslato' },
  { key: 'delivered', label: 'Dostavljeno' },
  { key: 'cancelled', label: 'Otkazano' },
  { key: 'returned', label: 'Vraćeno' },
  { key: 'ready_for_pickup', label: 'Spremno za preuzimanje' },
  { key: 'vip', label: 'VIP Članstvo' },
];

const LABEL_TO_KEY_MAP = Object.fromEntries(
    ORDER_STATUSES.map(status => [status.label, status.key])
);

export const getStatusKeyFromLabel = (label) => {
  return LABEL_TO_KEY_MAP[label] || 'unknown';
};

export const formatOrderStatusAsPillFromLabel = (label) => {
  const status = getStatusKeyFromLabel(label);
  return formatOrderStatusAsPill(status);
};